import React, { useEffect, useRef, useContext, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import axios from "axios";

const TradingChart = () => {
  const containerRef = useRef(null);
  
  const { trading_live_data, selectedValue, setSelectedValue, getLiveMarketData, getHistoricalMarketData, getPriceChange, bid_ask_data, setCurrentPrice, setLatestConid, setSymbolData, getOlChange, sethighPrice, setlowPrice, subdomain, apiProvider, setApiProvider, getNews, symbol_type, setSymbol_Type, thirdParyAccount, setBaseCurencySymbol, setCurencySymbol, finalData, setFinalData, setSymbolDetailsLoading } = useContext(AuthContext);
  let lastBar;
  const [allSymbols] = useState([
    { symbol: 'AAPL', full_name: 'AAPL', exchange: 'XNAS', type: 'stocks'}
  ])
  let new_symbol_data = [
    { symbol: 'AAPL', full_name: 'AAPL', exchange: 'XNAS', type: 'stocks'}
  ];

  const [searchCoinSymbol, setSearchCoinSymbol] = useState([{
    "active": true,
    "base_currency_name": null,
    "base_currency_symbol": null,
    "cik": "0000320193",
    "composite_figi": "BBG000B9XRY4",
    "currency_name": "usd",
    "currency_symbol": null,
    "delisted_utc": null,
    "last_updated_utc": "2025-02-19T00:00:00Z",
    "locale": "us",
    "market": "stocks",
    "name": "Apple Inc.",
    "primary_exchange": "XNAS",
    "share_class_figi": "BBG001S5N8V8",
    "source_feed": null,
    "ticker": "AAPL",
    "type": "CS"
  }]);

  const getSchemaForResolution = (resolution) => {
    switch (resolution) {
      case '1s':
        return '1s';
      case '1':
        return '1min';
      case '60':
        return '1h';
      case '1D':
        return '1d';
      case '1W':
        return '1w';
      case '1M':
        return '1m';
      case '6M':
        return '6m';
      case '1Y':
        return '1y';
      default:
        return '1m';
    }
  };

  const getTimeFrameForResolution = (resolution) => {
    switch (resolution) {
      case '1s':
        return '1min';
      case '1':
        return '1d';
      case '5':
        return '5d';
      case '30':
        return '1m';
      case '60':
        return '3m';
      case '120':
        return '6m';
      case '1D':
        return '1y';  // Resolves to 1 year
      case '1W':
        return '5y';  // For '5y', return '5y'
      case '1M':
        return '6y';
      default:
        return '1m';
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp * 1000); // Convert seconds to milliseconds
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}${month}${day}-${hours}:${minutes}:${seconds}`;
  };
  const formatTimestamp2 = (timestamp) => {
    const date = new Date(timestamp * 1000); // Convert seconds to milliseconds
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
    const day = date.getDate().toString().padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateString) => {
    const year = dateString.substring(0, 4);  // Extracts the year part (e.g., "2024")
    const month = dateString.substring(4, 6); // Extracts the month part (e.g., "12")
    const day = dateString.substring(6, 8);   // Extracts the day part (e.g., "27")

    // Create a new Date object
    const date = new Date(`${year}-${month}-${day}`);

    // Format the month as a 3-letter abbreviation
    const monthAbbreviation = date.toLocaleString('en-US', { month: 'short' });

    // Extract the last 2 digits of the year
    const yearShort = year.substring(2);

    // Return the formatted date in the "Dec24" format
    return `${monthAbbreviation}${yearShort}`;
  };

  async function processApiData(apiData, symbolType) {


    // Ensure apiData is an array before proceeding
    if (!Array.isArray(apiData)) {
      // console.error("apiData is not an array:", apiData);
      return;  // Exit early if apiData is not iterable
    }

    // Loop through each record in apiData
    for (const record of apiData) {
      if (symbolType == 'commodity') {
        const { symbol, futuresData } = record;

        // Check if the record has futuresData
        if (futuresData) {
          // Loop through each key in futuresData (e.g., GC, CL, SI, etc.)
          for (const futuresKey of Object.keys(futuresData)) {
            const futures = futuresData[futuresKey];

            // Loop through each future in the specific futures category (e.g., GC, CL, SI)
            for (const future of futures) {
              const { expirationDate, symbol, conid } = future;
              const formattedDate = formatDate(String(expirationDate));
              // Generate the symbol combining expirationDate and symbol
              const symbolWithExpiration = `${symbol}-${formattedDate}`;

              // Add to the symbols array
              new_symbol_data.push({
                symbol: symbolWithExpiration,
                full_name: record.companyHeader,
                exchange: record.description,
                conid: conid,
                type: 'commodity'

              });
              // console.log("if data:", symbolWithExpiration);  // Log the symbol with expiration
            }
          }
        } else if (symbol) {
          // For other records, just push them into symbols if they have a symbol
          new_symbol_data.push({
            symbol: symbol,
            full_name: record.companyHeader,
            exchange: record.description,
            type: 'commodity'
          });
          // console.log("else data:", symbol);  // Log the symbol
        }
      } else {
        new_symbol_data.push({
          symbol: record.ticker,
          full_name: record.name,
          exchange: record.primary_exchange,
          conid: record.conid,
          type: symbolType,
          base_currency_symbol: record.base_currency_symbol,
          currency_symbol: record.currency_symbol
        });
      }

    }

    // Log new_symbol_data after the loop completes
    // console.log("new_symbol_data:", new_symbol_data);
    // setAllSymbols(new_symbol_data)
    // console.log(allSymbols, "allSymbols:");
    return new_symbol_data
  }

  const searchNewSymbol = async (symbol, symbolType) => {
    let provider = 'IBKR';
    if (symbolType != 'commodity') {
      provider = 'polygon'
      setSymbol_Type(symbolType)
    } else {
      provider = 'IBKR'
      setSymbol_Type(symbolType)
    }
    
    const domain = localStorage.getItem('subDomain')
    try {
      const symbolData = {
        symbol: symbol,
        provider: provider,
        pattern: true,
        referrer: ""
      };

      if (provider === 'polygon') {
        symbolData.secType = symbolType;
      }

      const response = await axios.post(
        `https://${domain}.nodojicommodities.com/custom-apis/getSymbolDetailsPost`,
        symbolData
      );
      if (provider === 'polygon') {
        console.log(response.data.tickers);
        
        setSearchCoinSymbol(response.data.tickers);
        return response.data.tickers
      } else {
        return response.data;
      }
      
    } catch (error) {
      console.error("Error fetching symbol data:", error);
    }
  };

  // Custom datafeed for TradingView
  class CustomDatafeed {
    constructor(fetchLiveData, fetchHistoricalData, fetchLiveMarketData, fetchPriceChange, fetchBidNAsk, fetchOlChange, getNews, thirdParyAccount) {
      this.fetchLiveData = fetchLiveData;
      this.fetchHistoricalData = fetchHistoricalData;
      this.fetchLiveMarketData = fetchLiveMarketData;
      this.fetchPriceChange = fetchPriceChange;
      this.fetchBidNAsk = fetchBidNAsk;
      this.fetchOlChange = fetchOlChange;
      this.subscribers = {};
      this.cachedBars = {};
      this.isHistoricalDataFetched = false;
      this.previousResolution = null;
      this.symbols = allSymbols;
      this.getNews = getNews;
      this.thirdParyAccount = thirdParyAccount;
    }

    onReady(callback) {
      setTimeout(() => {
        const symbolsTypes = [
          { name: "Indices", value: "indices" },
          { name: "Forex", value: "fx" },
        ];
    
        if (this.thirdParyAccount === 'etrade') {
          symbolsTypes.push({ name: "Stock", value: "stocks" });
          // symbolsTypes.push({ name: "Options", value: "otc" });
        } else if (this.thirdParyAccount === 'coinbase') {
          symbolsTypes.push({ name: "Forex", value: "fx" });
          // symbolsTypes.push({ name: "Crypto", value: "crypto" });
        }
        // else{
        //   symbolsTypes.push({ name: "Forex", value: "fx" });
        //   symbolsTypes.push({ name: "Crypto", value: "crypto" });
        //   symbolsTypes.push({ name: "Stock", value: "stocks" });
        // }
    
        callback({
          supported_resolutions: ["1", "1H", "1D", "5D", "1W", "1M", "6M", "1Y"],
          supports_marks: false,
          supports_timescale_marks: false,
          supports_time: true,
          supports_search: true,
          symbols_types: symbolsTypes,
        });
      }, 0);
    }    

    resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
      const [symbol] = symbolName.split('-');
      setSelectedValue(symbolName);
      const specificSymbolNew = finalData.find(item => item.symbol === symbolName);

      const symbolInfo = {
        ticker: symbol,
        name: symbolName,
        type: specificSymbolNew?.type,
        session: '24x7',
        timezone: 'America/New_York',
        exchange: specificSymbolNew?.exchange,
        minmov: 1,
        pricescale: 100,
        has_intraday: true,
        has_daily: true,
        has_weekly_and_monthly: true,
        supported_resolutions: ["1", "1H", "1D", "5D", "1W", "1M", "6M", "1Y"],
        volume_precision: 2,
        data_status: 'streaming',
        minmov2: 0,
        pointvalue: 1,
        format: 'price',
        visible_plots_set: "C",
        description: specificSymbolNew?.exchange,
      };
      setTimeout(() => onSymbolResolvedCallback(symbolInfo), 0);
    }

    async getBars(symbolInfo, resolution, from, onHistoryCallback, onErrorCallback) {
      // console.log(symbolInfo, "symbolInfo")
      try {
        const period = getTimeFrameForResolution(resolution);
        setSymbolData(symbolInfo.name);
        setSymbolDetailsLoading(true);

        let provider = 'IBKR';
        if (symbol_type != 'commodity') {
          provider = 'polygon';
        }
        setApiProvider(provider);

        if(provider == 'polygon'){
          if(thirdParyAccount === 'coinbase'){
            const selectedSymbol = finalData?.find((item) => item.symbol == symbolInfo.name);
            if (selectedSymbol) {
              const { base_currency_symbol, currency_symbol } = selectedSymbol;
              setBaseCurencySymbol(base_currency_symbol);
              setCurencySymbol(currency_symbol);
            }
          }
        }

      if (from.firstDataRequest === false) {
        this.isHistoricalDataFetched = false;
        const lastBarDate = new Date(lastBar.time);
        lastBarDate.setHours(1, 1, 0, 0); // Set time to "01:01:00"
        const formattedFrom = Math.floor(lastBarDate.getTime() / 1000);
        from.from = formattedFrom;  
      }

        // Check if resolution has changed
        if (this.previousResolution !== resolution) {
          // console.log(`Resolution changed from ${this.previousResolution} to ${resolution}`);
          this.isHistoricalDataFetched = false;  // Reset flag to re-fetch data
          this.previousResolution = resolution;  // Update the previous resolution
        }

        const cacheKey = `${symbolInfo.name}_${resolution}_${from.from}_${from.to}`;
        if (this.cachedBars[cacheKey] && this.isHistoricalDataFetched) {
          // console.log('Returning cached bars for:', cacheKey);
          onHistoryCallback(this.cachedBars[cacheKey], { noData: false });
          return;
        }
        // console.log(this.cachedBars, 'Test append')
        // if (this.isHistoricalDataFetched) {
        //   // console.log('Returning cached data due to resolution not changing');
        //   onHistoryCallback(this.cachedBars[cacheKey] || [], { noData: false });
        //   return;
        // }

        if (provider === 'polygon') {
          this.isHistoricalDataFetched = false; // Force re-fetch on each call
        }

        const formattedDate = formatTimestamp(from.from);
        // console.log(from.from, from.to);
        const specificSymbol = finalData.find(item => item.symbol === symbolInfo.name);
        setLatestConid(specificSymbol?.conid);
        // this.isHistoricalDataFetched = true;
        const schema = getSchemaForResolution(resolution);
        let response;
        // Pass formattedDate as startTime if isRetrigger is true
        if(provider == 'IBKR') {
          if (!this.isHistoricalDataFetched || from.firstDataRequest === false) {
            this.isHistoricalDataFetched = true;
            // console.log('Passing formattedDate as startTime because isRetrigger is true');
            response = await this.fetchHistoricalData(schema, period, provider, symbolInfo.name, specificSymbol?.conid, formattedDate);
          } else {
            this.isHistoricalDataFetched = true;
            // console.log('No need to pass formattedDate as startTime');
            console.log('getBars fetch');
            response = await this.fetchHistoricalData(schema, period, provider, symbolInfo.name, specificSymbol?.conid);
          }
        } else {
          if (!this.isHistoricalDataFetched || from.firstDataRequest === false) {
            this.isHistoricalDataFetched = true;
            const newFormattedDate = formatTimestamp2(from.from);
            response = await this.fetchHistoricalData(schema, period, provider, symbolInfo.name, specificSymbol?.conid, newFormattedDate);
        
          } else {
            this.isHistoricalDataFetched = true;
            const newFormattedDate = formatTimestamp2(from.from);
            response = await this.fetchHistoricalData(schema, period, provider, symbolInfo.name, specificSymbol?.conid, newFormattedDate);
        
          }
        }
        

        // console.log(from.firstDataRequest);

        if (!response || !response.data || response.data.length === 0) {
          console.log('No historical data available');
          onHistoryCallback([], { noData: true });
          this.isHistoricalDataFetched = false;
          return;
        }
        let bars;
        if(provider == 'IBKR') {
          bars = response.data.map(entry => ({
            time: entry.t,
            open: entry.o,
            high: entry.h,
            low: entry.l,
            close: entry.c,
            volume: entry.v
          }));
        } else {
          bars = response.data.map(entry => ({
            time: entry.timestamp,
            open: entry.open,
            high: entry.high,
            low: entry.low,
            close: entry.close,
            volume: entry.volume,
            vwap: entry.vwap
          }));
        }
        

        // console.log(bars);

        // Prepend the new data to the existing cached data (if any)
        if (this.cachedBars[cacheKey]) {
          bars = [...this.cachedBars[cacheKey], ...bars]; // Prepend new bars to existing bars
        }

        lastBar = bars[0];
        // console.log('Last bar time:', lastBar?.time);

        this.cachedBars[cacheKey] = bars;

        // Pass the new and existing data to the callback
        onHistoryCallback(bars, { noData: false });
        // console.log(onHistoryCallback);

      } catch (error) {
        console.error('Error fetching historical data:', error);
        onErrorCallback(error.message);
      }
    }


    async subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) {
      if (this.subscribers[subscriberUID]) {
        this.unsubscribeBars(subscriberUID); // Unsubscribe from the previous symbol
      }

      // console.log(symbolIndexInList);
      const specificSymbol = finalData.find(item => item.symbol === symbolInfo.name);

      let provider = 'IBKR';
      if (symbol_type != 'commodity') {
        provider = 'polygon'
      }

      await this.fetchLiveMarketData(specificSymbol?.conid);
      await this.fetchPriceChange(specificSymbol?.conid, specificSymbol?.symbol, provider);
      await this.fetchOlChange(specificSymbol?.conid);
      this.fetchBidNAsk(symbolInfo.name, provider);
      this.getNews(symbolInfo.name);

      // Fetch live data every 5 seconds
      const fetchAndUpdate = async () => {
        try {

          const response = await this.fetchLiveData(symbolInfo.name, provider);

          if (response && response.data) {
            const data = response.data;
            if (data.length > 0) {
              let newBar;
              if(provider == 'IBKR') {
                newBar = {
                  time: data[data.length - 1].time / 1000000, // Convert nanoseconds to milliseconds
                  open: data[data.length - 1].open / 1000000000,
                  high: data[data.length - 1].high / 1000000000,
                  low: data[data.length - 1].low / 1000000000,
                  close: data[data.length - 1].close / 1000000000,
                  volume: data[data.length - 1].volume,
                };
              } else {
                newBar = {
                  time: data[0].last_trade.last_updated / 1000000, // Convert nanoseconds to milliseconds
                  open: data[0].session.open,
                  high: data[0].session.high,
                  low: data[0].session.low,
                  close: data[0].session.close,
                  volume: data[0].session.volume,
                };
              }
              

              setCurrentPrice(newBar.close);
              sethighPrice(newBar.high);
              setlowPrice(newBar.low);
              // Call the callback to update chart with new data
              onRealtimeCallback(newBar);
            } else {
              console.log('No new data available for subscribeBars');
            }
          } else {
            console.log('Invalid or empty response data in subscribeBars');
          }
        } catch (error) {
          console.error('Error fetching live data:', error);
        }
      };

      // Fetch live data every 3 seconds
      const interval = setInterval(fetchAndUpdate, 3000);
      this.subscribers[subscriberUID] = interval;
    }


    unsubscribeBars(subscriberUID) {
      if (this.subscribers[subscriberUID]) {
        clearInterval(this.subscribers[subscriberUID]);
        delete this.subscribers[subscriberUID];
      }
    }

    async searchSymbols(userInput, exchange, symbolType, onResultReadyCallback) {
      // console.log(userInput, "userInput");
      // console.log(exchange, "exchange");
      // console.log(symbolType, "symbolType");

      // Await the completion of searchNewSymbol
      let new_data = await searchNewSymbol(userInput, symbolType);  // Ensure we wait for this to finish
      let updated_data = await processApiData(new_data, symbolType);
      let final_data = this.symbols;
      // console.log("new_data:", new_data);
      // console.log("updated_data:", updated_data);
      if (updated_data !== undefined) {
        final_data = updated_data
      }
      setFinalData(final_data)
      // console.log('final_data', final_data);

      // Filter symbols after data has been fetched
      const filteredSymbols = final_data.filter(symbol => {
        const matchesInput = symbol.full_name.toLowerCase().includes(userInput.toLowerCase()) ||
          symbol.symbol.toLowerCase().includes(userInput.toLowerCase());
        const matchesExchange = !exchange || symbol.exchange === exchange;
        const matchesType = !symbolType || symbol.type === symbolType;
        return matchesInput && matchesExchange && matchesType;
      });
      // console.log(filteredSymbols, "filteredSymbols");

      const searchResults = filteredSymbols.map(symbol => ({
        symbol: symbol.symbol,
        full_name: symbol.full_name,
        description: symbol.full_name,
        exchange: symbol.exchange,
        type: symbol.type,
      }));

      // console.log(searchResults);

      if (searchResults.length > 0) {
        // const selectedSymbol = searchResults[0].symbol;
        // setSelectedValue(searchResults[0].symbol);
        this.isHistoricalDataFetched = false;
      }

      onResultReadyCallback(searchResults);
    }
  }

  useEffect(() => {
    // if (!thirdParyAccount) {
    //   console.log("thirdParyAccount is not available yet");
    //   return; // Don't initialize CustomDatafeed until thirdParyAccount is available
    // }
  
    if (!window.TradingView) {
      console.error('TradingView library not loaded!');
      return;
    }
  
    const widgetOptions = {
      container: containerRef.current,
      library_path: '/charting_library/',
      datafeed: new CustomDatafeed(
        trading_live_data,
        getHistoricalMarketData,
        getLiveMarketData,
        getPriceChange,
        bid_ask_data,
        getOlChange,
        getNews,
        thirdParyAccount // Pass thirdParyAccount here
      ),
      symbol: selectedValue,
      interval: '1',
      locale: 'en',
      fullscreen: true,
      autosize: true,
      theme: 'Dark',
      time_frames: [
        { text: "1D", resolution: "1", description: "1 Day" },
        { text: "5D", resolution: "5", description: "5 Days" },
        { text: "1M", resolution: "30min", description: "1 Month" },
        { text: "3M", resolution: "60", description: "3 Months" },
        { text: "6M", resolution: "120", description: "6 Months" },
        { text: "1y", resolution: "1D", description: "1 Year" },
        { text: "5y", resolution: "1W", description: "5 Years" },
        { text: "1000y", resolution: "1M", description: "All", title: "All" },
      ],
      custom_css_url: "/charting_library/custom_styles.css",
    };
  
    const tvWidget = new window.TradingView.widget(widgetOptions);
  
    tvWidget.onChartReady(() => {
      tvWidget.activeChart().onVisibleRangeChanged().subscribe(null, ({ from, to }) => {
        widgetOptions.datafeed.isHistoricalDataFetched = false;
        const lastBarDate = new Date(lastBar.time);
        lastBarDate.setHours(1, 1, 0, 0); // Set time to "01:01:00"
      });
    });
  
    return () => {
      if (tvWidget) tvWidget.remove();
    };
  }, [selectedValue, thirdParyAccount]);
  


  return <div className='main-card home-chart mt-3' id="trading-chart" ref={containerRef} />;
};

export default TradingChart;